import {computed, inject, InputSignal} from '@angular/core';
import {IItem} from '../../types/IItem';
import {ResultsStore} from '../../shared/store/results.store';
import {CompareStore} from './compare.store';
import {background, containerClasses, stars} from '../../shared/utils/comparison.utils';
import {getFeatureString, weightedCost, weightedPrice} from '../../shared/utils/item.utils';
import {ICompareItem} from '../../types/ICompareItem';

export abstract class CompareItemBase {
  abstract level: InputSignal<string>;
  abstract item: InputSignal<ICompareItem>;

  protected resultsStore = inject(ResultsStore);
  protected compareStore = inject(CompareStore);

  price = computed(() => weightedPrice(this.item()));
  cost = computed(() => weightedCost(this.item()));

  addonForItem = computed(() => this.resultsStore.getAddonsForItem()(this.item().id, this.price(), this.quantity()));

  subtotal = computed(() => this.addonForItem()?.subtotal_before_addons ?? 0);

  outTheDoorPricing = computed(() => this.compareStore.getCompareAddonsForItem()(this.item().id, this.price(), this.quantity())?.total_after_addons ?? 0);

  tax = computed(() => this.compareStore.getCompareAddonsForItem()(this.item().id, this.price(), this.quantity())?.tax_after_addons ?? 0);

  loading = computed(() => this.compareStore.isCompareAddonsPending() || !this.outTheDoorPricing());

  quantity = computed(() => this.item().sourcing.reduce((sum, s) => sum + s.selected_quantity, 0))

  fees = computed(() => {
    const item_fees = this.addonForItem()?.fees;

    return this.compareStore.unified_addons().fees.map((fee) => {
      return item_fees?.find((ifee) => {
        return ifee.fee_id == fee.fee_id;
      });
    }) || [];
  });

  addons = computed(() => {
    const item_addons = this.addonForItem()?.addons;

    return this.compareStore.unified_addons().addons.map((fee) => {
      return item_addons?.find((iaddon) => {
        return iaddon.item_id == fee.item_id;
      });
    }) || [];
  });


  isAddonSelected(id: number | string): boolean {
    return this.compareStore.selected_addon_ids().has(id);
  }

  protected readonly containerClasses = containerClasses;
  protected readonly background = background;
  protected readonly stars = stars;
  protected readonly getFeatureString = getFeatureString;
}
